import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { queryKeys } from "@/lib/queryClient";
import type { UUID, WorkspaceMember } from "@/lib/types";

export function useWorkspaceMembers(workspaceId: UUID | undefined) {
  return useQuery<WorkspaceMember[]>({
    enabled: Boolean(workspaceId),
    queryKey: workspaceId
      ? queryKeys.workspaceMembers(workspaceId)
      : ["workspaces", "void", "members"],
    queryFn: () => api.listWorkspaceMembers(workspaceId as UUID),
    staleTime: 5 * 60_000,
  });
}
